import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telephone-directory',
  templateUrl: './telephone-directory.component.html'
})
export class TelephoneDirectoryComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
